import { CreditPaymentPayload, postCreditPayment } from "../api/credit";

export const makeCreditPayment = async (payload: CreditPaymentPayload) => {
  const data = await postCreditPayment(payload);
  return data;
};
